import React from "react";
import "./EditNetworkProfileDialog.css";
import { withTranslation } from "react-i18next";
import { Accordion, Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import MarkDownEditor from "../../../../components/markdownEditor/MarkDownEditor";
import Switch from "react-switch";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import BaseSelect from "../../../../components/baseSelect/BaseSelect";

class EditNetworkProfileDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      name: {
        defaultValue: "",
        initValid: true,
        rule: value => ValidationHelper.isNonEmptyStringOfLength(value, 3, 50)
      },
      description: {
        defaultValue: ValidationHelper.getDefaultValueExtendedDescription(),
        initValid: true,
        rule: ValidationHelper.isExtendedDescription
      },
      isPublished: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      cloudProfileId: {
        defaultValue: undefined,
        initValid: true,
        rule: ValidationHelper.isNonEmptyString
      }
    };

    this.state = {
      apiError: "",
      dialogApiError: "",
      validation: ValidationHelper.getValidation(this.validationDefinition)
    };

    this.handleChange = this.handleChange.bind(this);
    this.refreshValidation = this.refreshValidation.bind(this);
    this.onHide = this.onHide.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({
      validation: Object.assign(
        {},
        ValidationHelper.update(event, this.state.validation)
      )
    });
  }

  refreshValidation() {
    const validationDefinition = {
      name: {
        defaultValue: (" " + this.props.networkProfile.name).substr(1),
        initValid: true,
        rule: value => ValidationHelper.isNonEmptyStringOfLength(value, 3, 50)
      },
      description: {
        defaultValue:
          Object.assign({}, this.props.networkProfile.description) ||
          ValidationHelper.getDefaultValueExtendedDescription(),
        initValid: true,
        rule: ValidationHelper.isNonEmptyExtendedDescription
      },
      isPublished: {
        defaultValue: this.props.networkProfile.isPublished
          ? true
          : false || false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      cloudProfileId: {
        defaultValue: this.props.networkProfile.cloudProfileId,
        initValid: true,
        rule: ValidationHelper.isString
      }
    };
    this.setState({
      validation: ValidationHelper.getValidation(
        this.props.networkProfile
          ? validationDefinition
          : this.validationDefinition
      )
    });
  }

  componentDidMount() {
    this.refreshValidation();
  }

  async onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["proxyUrls"] = this.props.networkProfile.proxyUrls;
      validatedData["denyProxyUrls"] = this.props.networkProfile.denyProxyUrls;
      await this.props.onSubmit(validatedData);
      this.refreshValidation();
    }
  }

  onHide() {
    this.props.onHide(
      ValidationHelper.hasChanged(this.state.validation),
      this.refreshValidation
    );
  }

  render() {
    const { t } = this.props;
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        size="lg"
        title={t("SingleNetworkProfile.EditModal.Title")}
        dialogApiError={this.props.dialogApiError}
        leftButtonCallback={this.onHide}
        leftButtonText={t("DialogCancel")}
        leftButtonVariant="black"
        rightButtonCallback={this.onSubmit}
        rightButtonText={t("SingleNetworkProfile.EditModal.Form.Submit")}
        rightButtonIsLoading={this.props.isSaving}
        rightButtonDisabled={!this.state.validation._isValid ||
          !ValidationHelper.hasChanged(this.state.validation) ||
          this.props.networkProfile?.isLocked ||
          this.props.isSaving
        }
        rightButtonVariant="green"
        body={(<Container className="pl-0 pr-0">
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Form onSubmit={this.onSubmit}>
            <Accordion defaultActiveKey="0">
              <Card className="accordion-top-card">
                <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    className="acc-link"
                    eventKey="0"
                  >
                    <FontAwesomeIcon
                      icon={faExclamationCircle}
                      className={
                        this.state.validation.name.isValid &&
                          this.state.validation.isPublished
                          ? "display-none"
                          : "mr-2 color-red"
                      }
                    />
                    <span>
                      {t("SingleNetworkProfile.EditModal.Form.ToggleBasic")}
                    </span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <Form.Group controlId="formName">
                      <Form.Label>
                        {t("SingleNetworkProfile.EditModal.Form.Name")}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder={t(
                          "SingleNetworkProfile.EditModal.Form.NamePlaceholder"
                        )}
                        value={this.state.validation.name.value}
                        isInvalid={!this.state.validation.name.isValid}
                        onChange={this.handleChange}
                        disabled={this.props.networkProfile?.isLocked}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(
                          "SingleNetworkProfile.EditModal.Form.ValidationError.Name"
                        )}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formSwitchIsPublished">
                      <Switch
                        className="isPublishedSwitch"
                        onColor="#54BF8D"
                        checked={this.state.validation.isPublished.value}
                        onChange={state => {
                          this.handleChange({
                            target: {
                              name: "isPublished",
                              value: state
                            }
                          });
                        }}
                        height={18}
                        width={40}
                        disabled={this.props.networkProfile?.isLocked}
                      />
                      <Form.Label>
                        {t("SingleNetworkProfile.EditModal.Form.IsPublished")}
                      </Form.Label>
                      <Form.Control
                        type="hidden"
                        isInvalid={!this.state.validation.isPublished.isValid}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(
                          "SingleNetworkProfile.EditModal.Form.ValidationError.IsPublished"
                        )}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formSelectCloudProfile">
                      <Form.Label>
                        {t(
                          "SingleNetworkProfile.EditModal.Form.CloudProfile"
                        )}
                      </Form.Label>
                      <BaseSelect
                        options={this.props.cloudProfiles}
                        onChange={s => {
                          this.handleChange({
                            target: {
                              name: "cloudProfileId",
                              value: s?.id
                            }
                          });
                        }}
                        getOptionLabel={option => option.name}
                        getOptionValue={option => option.id}
                        placeholder={t(
                          "SingleNetworkProfile.EditModal.Form.CloudProfilePlaceholder"
                        )}
                        value={this.props.cloudProfiles
                          .filter(
                            o =>
                              o.id ===
                              this.state.validation.cloudProfileId.value
                          )
                          .shift()}
                      />
                      <Form.Control
                        type="hidden"
                        isInvalid={
                          !this.state.validation.cloudProfileId.isValid
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(
                          "SingleNetworkProfile.EditModal.Form.ValidationError.CloudProfile"
                        )}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
            <Accordion>
              <Card className="accordion-mid-card">
                <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    className="acc-link"
                    eventKey="2"
                  >
                    <FontAwesomeIcon
                      icon={faExclamationCircle}
                      className={
                        this.state.validation.isPublished.isValid
                          ? "display-none"
                          : "mr-2 color-red"
                      }
                    />
                    <span>
                      {t("SingleNetworkProfile.EditModal.Form.Description")}
                    </span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    <Form.Group>
                      <MarkDownEditor
                        disabled={this.props.networkProfile?.isLocked}
                        defaultValue={this.props.networkProfile ? this.props.networkProfile.description :
                            ValidationHelper.getDefaultValueExtendedDescription()}
                        onChange={value =>
                          this.handleChange({
                            target: {
                              name: "description",
                              value: value
                            }
                          })
                        }
                      />
                      <Form.Control
                        type="hidden"
                        isInvalid={!this.state.validation.description.isValid}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(
                          "SingleNetworkProfile.EditModal.Form.ValidationError.Description"
                        )}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </Form>
        </Container>)}
      />
    );
  }
}

export default withTranslation()(EditNetworkProfileDialog);
